export const setBusinessNameValidations = (businessName: string) => {
  const hasError = false;
  const message = "";

  if (businessName === "") {
    return {
      hasError: true,
      message: "Business Name is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setBusinessDescriptionValidations = (
  businessDescription: string
) => {
  const hasError = false;
  const message = "";

  if (businessDescription === "") {
    return {
      hasError: true,
      message: "Business Description is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setBusinessTypeValidations = (businessType: string) => {
  const hasError = false;
  const message = "";

  if (businessType === "") {
    return {
      hasError: true,
      message: "Business Type is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setBusinessSectorValidations = (businessSector: string) => {
  const hasError = false;
  const message = "";

  if (businessSector === "") {
    return {
      hasError: true,
      message: "Business Sector is required",
    };
  }
  return {
    hasError,
    message,
  };
};
